export default "__VITE_ASSET__BwyC6wjp__"